module.exports = __webpack_public_path__ + "img/conny-stage6.8c53b4e3.png";